module.exports = __webpack_public_path__ + "img/dagang_title2.f0e4a744.jpg";